import React, { type ReactNode } from 'react';

type ErrorProps = {
  name?: string;
  id?: string;
  role?: React.AriaRole;
  children?: ReactNode;
};

export function Error({ children, id, role }: ErrorProps) {
  return (
    <p id={id} role={role} className="mx-4 my-0 text-red-600">
      {children}
    </p>
  );
}
